export enum BRANCH_KIND {
  OTHER = 'other',
  FEATURE = 'feature',
  BUG_FIX = 'bugfix',
  HOT_FIX = 'hotfix',
  RELEASE = 'release',
}
